// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/errors.scss
// module id = 70
// module chunks = 0